export default "__VITE_ASSET__BV5Mwz1a__"